import { remainingFeatSlots } from '../shared/rules/featSelection.mjs';
export function calculateFeatPointsLeft(occupation = [], feat = [], abilityScoreImprovement = {}) { return remainingFeatSlots({occupation,feat,abilityScoreImprovement}); }
